import { Image } from '@nextui-org/react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { LogoText, PlusIcon } from '../../../assets';
import { Button, Tabs } from '../../../components';
import { ThemeProp } from '../../../theme/Themes';

export const headerHeight = '3.5rem';
export const subheaderHeight = '3.5rem';

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: ${headerHeight};
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: 0 1rem;
    width: 100%;
    justify-content: flex-end;
  }
`;

export const Divider = styled.div`
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
  height: 2rem;
  margin: auto 1rem;
  opacity: 10%;
  width: 1px;
`;

export const Link = styled(NavLink)`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
  margin: auto 0.75rem auto 0;
  padding: 5px 10px;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  border-radius: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.active {
    background: rgba(117, 40, 190, 0.1);
    color: ${(props: ThemeProp) => props.theme.colors.primary.c500};
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const AdminIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const UpgradePlanLink = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.s};
  color: ${(props: ThemeProp) => props.theme.colors.primary.c500};
  cursor: pointer;

  &:hover {
    color: ${(props: ThemeProp) => props.theme.colors.primary.c500};
    text-decoration-line: underline;
  }
`;

export const HeaderItemsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const NewButton = styled(Button)`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  gap: unset;
  height: 2rem;
  min-width: unset;

  .nextui-button-icon {
    margin-right: 0.5rem;
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
  }
`;

export const StyledPlusIcon = styled(PlusIcon)`
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
`;

export const LogoHeader = styled.div`
  display: none;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: ${headerHeight};
  flex-shrink: 0;
  border-bottom: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  padding: 0 1rem;
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: flex;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
`;

export const LogoHeaderLeftContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  overflow: hidden;
`;

export const AppImage = styled(Image)`
  margin: 0;
`;

export const AppLogoText = styled(LogoText)`
  fill: ${(props: ThemeProp) => props.theme.colors.primary};
`;

export const StyledTabs = styled(Tabs)`
  width: 100%;
  padding: 0.5rem 1.5rem;
  padding-top: 1rem;
  overflow-x: auto;
  background-color: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
  display: none;
  align-self: flex-end;
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: flex;
  }
`;
